jQuery(document).ready(function ($) {

    var rangeSlider = function(){
        var slider = '.js-range',
            range = $('.js-range__range'),
            value = '.js-range__value';

        range.on('input', function(){
            $(this).parents(slider).find(value).val(this.value);
        });
    };
    rangeSlider()

});
